"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "agenx_cookie_consent_v1";

/**
 * SSR-safe: we only render on the client. Reading localStorage in a lazy
 * initializer would still run on the server, so we use mounted + effect.
 * The first client render returns null (matches server) so no hydration
 * mismatch; the effect then sets visible. Result: no flash of missing
 * banner on first paint, banner appears right after.
 */
export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 p-4 md:p-6 pointer-events-none"
      role="region"
      aria-label="Cookie notice"
      aria-live="polite"
    >
      <div className="max-w-lg mx-auto pointer-events-auto rounded-xl border bg-card shadow-lg p-5 text-sm backdrop-blur">
        <p className="mb-3 text-muted-foreground leading-relaxed">
          We use essential cookies for sign-in and preferences, and similar technologies to run the product.
          See our{" "}
          <Link href="/privacy" className="underline text-foreground">
            Privacy
          </Link>{" "}
          policy.
        </p>
        <Button
          size="sm"
          onClick={() => {
            try {
              localStorage.setItem(STORAGE_KEY, "1");
            } catch {
              /* ignore */
            }
            setVisible(false);
          }}
        >
          OK, got it
        </Button>
      </div>
    </div>
  );
}
